$(document).ready(function() {
  //POA contact form popup
  $('.product-single__poa-button').magnificPopup({
    type: 'inline',
    preloader: false,
    focus: '#ContactFormName',
    closeBtnInside: true,
    callbacks: {
      beforeOpen: function() {
        if($(window).width() < 700) {
          this.st.focus = false;
        } else {
          this.st.focus = '#name';
        }
      }
    }
  });

  //open the modal by default if the form has been posted (for showing messages)
  var urlParams = new URLSearchParams(window.location.search);
  if( urlParams.has('contact_posted') ){
    $('.product-single__poa-button').click();
  }

});